var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-divider',{attrs:{"content-position":"left"}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.text)?_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }